import moment from "moment";

export const PUBLIC_HOLIDAYS_COLUMNS = [
  { name: "holiday", align: "left" },
  { name: "date", align: "left" },
  { name: "day", align: "left" },
  { name: "status", align: "center" },
  { name: "actions", align: "center" },
];

export const PUBLIC_HOLIDAYS_PAGE_SIZE = 10;

export const PUBLIC_HOLIDAYS_MESSAGES = {
  empty: "No public holidays yet. Add one to get started.",
  emptyFiltered: "No public holidays match your filters.",
  nameRequired: "Name is required.",
  dateRequired: "Date is required.",
  rangeRequired: "Start and end dates are required for range.",
  invalidDateFormat: "Invalid date format.",
  endBeforeStart: "End date must be on or after start date.",
  noWeekdaysInRange: "Selected range has no weekdays.",
  adminNotFound: "Admin not found.",
  atLeastOneDate: "At least one date is required.",
};

/**
 * Returns all weekdays (Mon–Fri) between start and end (inclusive) as YYYY-MM-DD strings.
 * Accepts either YYYY-MM-DD strings or moment instances.
 */
export const getWeekdaysInRange = (start, end) => {
  if (!start || !end) return [];

  const startMoment = moment.isMoment(start) ? start.clone() : moment(start, "YYYY-MM-DD");
  const endMoment = moment.isMoment(end) ? end.clone() : moment(end, "YYYY-MM-DD");

  if (!startMoment.isValid() || !endMoment.isValid()) return [];
  if (endMoment.isBefore(startMoment, "day")) return [];

  const dates = [];
  const current = startMoment.clone();

  while (current.isSameOrBefore(endMoment, "day")) {
    const day = current.day(); // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) {
      dates.push(current.format("YYYY-MM-DD"));
    }
    current.add(1, "day");
  }

  return dates;
};

